import axios from "axios";
import qs from "qs";

import { API_HOST } from "../config";

const server = axios.create({
  baseURL: `${API_HOST}/merlin`,
  withCredentials: true,
  mode: "cors",
});

const appendToken = (request) => {
  const newRequest = request;
  const token = localStorage.getItem("token");
  if (token) newRequest.headers.Authorization = `Token ${token}`;
  return newRequest;
};
const handleResponse = (response) => response;
const handleError = (error) => error.response;

server.defaults.paramsSerializer = (params) => qs.stringify(params, { encode: false });
server.interceptors.response.use(handleResponse, handleError);
server.interceptors.request.use(appendToken);

export default server;
